


















































































import axios from "axios"
import Vue from "vue"
import infoComponent from "./components/info.vue"
import { InfoModel } from "model/InfoModel"
import { Common } from "./../common/common"

export default Vue.extend({
  name: "app",
  components: {
    infoComponent,
  },
  data() {
    return {
      mailAddress: "",
      password: "",
      errMsg: "",
      infoList: [] as InfoModel[],
    }
  },
  watch: {
    //
  },
  /** Vue構築完了時の処理 */
  created: function init() {

    if (window.location.search !== "") {
      const map = {} as { [key: string]: string }
      const params = window.location.search.slice(1).split("&")
      for (const index in params) {
        if (params.hasOwnProperty(index)) {
          const element = params[index]
          const temp = element.split("=")
          const key = temp[0]
          const value = temp[1]
          map[key] = value
        }
      }
      if (map.err === "1") {
        this.errMsg = "メールアドレスまたはパスワードが一致しません。"
      } else if (map.err === "2") {
        this.errMsg = "有効期限が切れています。再度「パスワードを忘れた場合こちら」から再設定メールを送信してください。"
      }

    }


    // console.log(document.cookie)
    const cookies = decodeURI(document.cookie).split(";")

    for (let cookie of cookies) {
      // 先頭の空白除去
      cookie = cookie.replace(/^\s+/, "")
      const tmp = cookie.split("=")
      if (tmp[0] === "version") {
        console.log("version:" + tmp[1])
      }
    }

    // axios({
    //   method: "get",
    //   url: "/info/data",
    // }).then((response) => {
    //   const data = response.data as any
    //   this.infoList = data
    //   console.log(data)

    // })

  },
  methods: {
    //
  },
})
